// extracted by mini-css-extract-plugin
export var quantityInput = "_nn-0";